import useBeautyFilterStore from 'stores/beautyFilter/beautyFilterStore';
import useBanubaGuard from 'hooks/beautyFilter/useBanubaGuard';
import { BeautyFilterMenuItem } from 'types/beautyFilter';

const useBeautyFilterMenu = () => {
  const store = useBeautyFilterStore();
  const { items, selectedItem, setSelectedItem } = store.menu;
  const { resetSelectedKey: resetSelectedBeautyKey, resetSelectedSubKey: resetSelectedBeautySubKey } = store.beauty;
  const { resetSelectedKey: resetSelectedMakeupKey, resetSelectedSubKey: resetSelectedMakeupSubKey } = store.makeup;
  const { showUnavailableToast, isItemDisabled } = useBanubaGuard();

  const isItemSelected = (itemId: string) => selectedItem.id === itemId;

  const handleButtonClick = (item: BeautyFilterMenuItem) => {
    if (isItemDisabled(item)) {
      showUnavailableToast();
      return;
    }
    if (item.id === selectedItem.id) return;
    setSelectedItem(item);
    resetSelectedBeautyKey();
    resetSelectedMakeupKey();
    resetSelectedBeautySubKey();
    resetSelectedMakeupSubKey();
  };

  return {
    items,
    handleButtonClick,
    isItemSelected,
    isItemDisabled,
  };
};

export default useBeautyFilterMenu;
